<template>
  <section :class="['section', 'child-view', 'section--expertise', 'section--expertise-child', 'section--expertise-ui']">
    <div class="wrapper" :class="{ 'with-modal': isModalVisible}">
      <div class="content">
        <div class="heading">
          <div class="back-btn">
            <router-link
              :to="`/expertise`">
            </router-link>
            <span>back</span>
          </div>
        </div>
        <div class="expertise-holder">
          <ul class="parts-number">
            <li class="number-2">
              <span class="number">/2</span>
              <span class="text">UI Design</span>
              <ul class="list-tools">
                <li>
                  <img src="../assets/images/programs_icons/adobeillustrator.svg" alt="adobe illustrator">
                </li>
                <li>
                  <img src="../assets/images/programs_icons/adobephotoshop.svg" alt="adobe photoshop">
                </li>
                <li>
                  <img src="../assets/images/programs_icons/figma.svg" alt="figma">
                </li>
                <li>
                  <img src="../assets/images/programs_icons/adobexd.svg" alt="adobe xd">
                </li>
                <li>
                  <img src="../assets/images/programs_icons/sketch.svg" alt="sketch">
                </li>
                <li>
                  <img src="../assets/images/programs_icons/invision.svg" alt="invision">
                </li>
                <li>
                  <img src="../assets/images/programs_icons/zeplin.svg" alt="zeplin">
                </li>
                <li>
                  <img src="../assets/images/programs_icons/adobeaftereffect.svg" alt="adobe after effects">
                </li>
                <li>
                  <img src="../assets/images/programs_icons/marvel.svg" alt="marvel">
                </li>
                <li>
                  <img src="../assets/images/programs_icons/adobe_animate.svg" alt="adobe animate">
                </li>
              </ul>
            </li>
          </ul>
          <div class="expertise-container">
            <span class="circle-title">UI</span>
            <div class="circle-holder">
              <ul class="circle-block">
                <li class="circle-button size-1">
                  <div class="text-holder"
                    @click="openModal('layout')">
                    <span class="text">Layout</span>
                  </div>
                </li>
                <li class="circle-button size-2">
                  <div class="text-holder"
                    @click="openModal('typography')">
                    <span class="text">Typography</span>
                  </div>
                </li>
                <li class="circle-button size-1">
                  <div class="text-holder"
                    @click="openModal('color-scheme')">
                    <span class="text">Color Scheme</span>
                  </div>
                </li>
                <li class="circle-button size-2">
                  <div class="text-holder"
                    @click="openModal('micro-animation')">
                    <span class="text">Micro Animation</span>
                  </div>
                </li>
                <li class="circle-button size-2">
                  <div class="text-holder"
                    @click="openModal('design-system')">
                    <span class="text">Design System</span>
                  </div>
                </li>
                <li class="circle-button size-2">
                  <div class="text-holder"
                    @click="openModal('prototypes')">
                    <span class="text">Prototypes</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div><!--end content-->
    </div>
    <window-modal v-show="isModalVisible" v-model="modalData[activeItem]" @close="closeModal"></window-modal>
  </section>
</template>

<script>
import Footer from '@/components/UI/Footer';
import { mapActions } from 'vuex';
import WindowModal from '@/components/modals/WindowModal.vue';

export default {
  mounted() {
    document.addEventListener('keydown', this.onKeydown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeydown);
  },
  data() {
    return {
      isModalVisible: false,
      activeItem: 'layout',
      modalData: {
        layout: {
          title: 'Layout',
          content: 'Layouts use uniform elements and spacing to encourage consistency across platforms, environments, and screen sizes.',
          linkUrl: 'https://www.figma.com/proto/Vi0Ug4vuU1O7xmT5H2zAKh/UX-Methods-MD-Team-Library?node-id=4653-7309&viewport=-9614%2C-10%2C0.14&t=gHZFkB93xJuKAIr2-1&scaling=scale-down-width&content-scaling=fixed&starting-point-node-id=4653%3A7309&page-id=0%3A1',
          sizeClass: 'size-1',
        },
        typography: {
          title: 'Typography',
          content: 'Typography in UI design involves the selection and application of fonts, typefaces, and text styles to enhance the readability, aesthetics, and overall user experience of a digital interface. It plays a critical role in conveying information, establishing hierarchy, and creating a cohesive visual identity for the user interface.',
          linkUrl: 'https://www.figma.com/proto/Vi0Ug4vuU1O7xmT5H2zAKh/UX-Methods-MD-Team-Library?node-id=4653-7314&viewport=-9614%2C-10%2C0.14&t=gHZFkB93xJuKAIr2-1&scaling=scale-down-width&content-scaling=fixed&starting-point-node-id=4653%3A7314&page-id=0%3A1',
          sizeClass: 'size-2',
        },
        'requirements-review': {
          title: 'Requirements Review',
          content: 'A "Requirements Review" is a systematic examination of project or product requirements to ensure clarity, completeness, and consistency. It involves analyzing the documented requirements to verify that they accurately capture the desired functionalities and outcomes, serving as a crucial quality control step in the early stages of project development.',
          linkUrl: 'https://mobidev.biz',
          sizeClass: 'size-3',
        },
        'color-scheme': {
          title: 'Color Scheme',
          content: 'Color scheme in UI design refers to the deliberate selection and coordination of colors used within a digital interface. It serves to create a visually pleasing and coherent design, establish hierarchy, convey information, and evoke specific emotions or associations that align with the brand or user experience goals.',
          linkUrl: 'https://www.figma.com/proto/Vi0Ug4vuU1O7xmT5H2zAKh/UX-Methods-MD-Team-Library?node-id=4653-7317&viewport=-9614%2C-10%2C0.14&t=gHZFkB93xJuKAIr2-1&scaling=scale-down-width&content-scaling=fixed&starting-point-node-id=4653%3A7317&page-id=0%3A1',
          sizeClass: 'size-1',
          positionClass: 'down-position',
        },
        'micro-animation': {
          title: 'Micro Animation',
          content: 'Micro animations in UI design are subtle and often brief animations or transitions that add interactivity and visual feedback to user interactions with a digital interface. They are used to enhance the user experience by providing cues, confirming actions, or guiding users through the interface, making interactions more intuitive and engaging.',
          linkUrl: 'https://www.figma.com/proto/Vi0Ug4vuU1O7xmT5H2zAKh/UX-Methods-MD-Team-Library?node-id=4653-7311&viewport=-9614%2C-10%2C0.14&t=gHZFkB93xJuKAIr2-1&scaling=scale-down-width&content-scaling=fixed&starting-point-node-id=4653%3A7311&page-id=0%3A1',
          sizeClass: 'size-2',
          positionClass: 'down-position',
        },
        'design-system': {
          title: 'Design System',
          content: 'A “Design System” in UI design is a comprehensive collection of standardized design elements, guidelines, and principles that ensure consistency and cohesiveness across a digital product or application. It includes components like typography, color schemes, UI elements, spacing, and guidelines for creating a seamless and user-friendly interface while streamlining the design and development process.',
          linkUrl: 'https://www.figma.com/proto/Vi0Ug4vuU1O7xmT5H2zAKh/UX-Methods-MD-Team-Library?node-id=4653-7320&viewport=-9614%2C-10%2C0.14&t=gHZFkB93xJuKAIr2-1&scaling=scale-down-width&content-scaling=fixed&starting-point-node-id=4653%3A7320&page-id=0%3A1',
          sizeClass: 'size-2',
          positionClass: 'down-position',
        },
        prototypes: {
          title: 'Prototypes',
          content: 'Prototypes in UI design are interactive, often low-fidelity representations of a user interface that allow designers and stakeholders to visualize and test the functionality and user experience of a digital product before development. They serve as a crucial step in the design process, helping to gather feedback, iterate on design concepts, and identify potential issues early in the development cycle.',
          linkUrl: 'https://www.figma.com/proto/Vi0Ug4vuU1O7xmT5H2zAKh/UX-Methods-MD-Team-Library?node-id=4653-7310&viewport=-9614%2C-10%2C0.14&t=gHZFkB93xJuKAIr2-1&scaling=scale-down-width&content-scaling=fixed&starting-point-node-id=4653%3A7310&page-id=0%3A1',
          sizeClass: 'size-2',
        },
      },
    };
  },
  methods: {
    ...mapActions({ fetchExpertisePageContent: '/expertise/expertise:fetch' }),
    openModal(activeItemName) {
      this.activeItem = activeItemName;
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    onKeydown(event) {
      if (event.key === 'Escape') {
        this.closeModal();
      }
    },
  },
  components: {
    Footer,
    WindowModal,
  },
};
</script>



// WEBPACK FOOTER //
// src/views/ExpertiseUi.vue